import { tableColumnsType } from "../components/edit-table/editable-table";
import linkExceptions from "../services/Utils/linkExceptions";

const shoppingCartColumns = (): tableColumnsType[] => {
  return (
    [
      {
        Header: 'Zone',
        accessor: 'zoneName',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Consumable Code',
        accessor: 'itemcode',
        editType: 'inputField',
        options: [],
        linkType: true,
        linkExceptions: linkExceptions
      },
      {
        Header: 'Equipment Name',
        accessor: 'equipmentName',
        editType: 'inputField',
        options: [],
        linkType: true
      },
      {
        Header: 'Consumable Name',
        accessor: 'consumableName',
        editType: 'inputField',
        options: []
      },

      {
        Header: 'Quantity',
        accessor: 'itemcount',
        editType: 'inputField',
        options: []
      },
    ]
  )
}

export default shoppingCartColumns;
